import "core-js/modules/es6.array.is-array";
import _slicedToArray from "/opt/build/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useState, useRef } from 'react'; // import ResizeObserver from 'resize-observer-polyfill'
// From https://github.com/ZeeCoder/use-resize-observer

var useResizeObserver = function useResizeObserver() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$defaultWidth = _ref.defaultWidth,
      defaultWidth = _ref$defaultWidth === void 0 ? 1 : _ref$defaultWidth,
      _ref$defaultHeight = _ref.defaultHeight,
      defaultHeight = _ref$defaultHeight === void 0 ? 1 : _ref$defaultHeight;

  var _ref2 = typeof window !== 'undefined' ? window : {},
      ResizeObserver = _ref2.ResizeObserver;

  var hasSupport = typeof ResizeObserver !== 'undefined';
  var ref = useRef(null);

  var _useState = useState(defaultWidth),
      _useState2 = _slicedToArray(_useState, 2),
      width = _useState2[0],
      changeWidth = _useState2[1];

  var _useState3 = useState(defaultHeight),
      _useState4 = _slicedToArray(_useState3, 2),
      height = _useState4[0],
      changeHeight = _useState4[1];

  useEffect(function () {
    if (!ResizeObserver) {
      return;
    }

    var element = ref.current;
    var resizeObserver = new ResizeObserver(function (entries) {
      if (!Array.isArray(entries)) {
        return;
      } // Since we only observe the one element, we don't need to loop over the
      // array


      if (!entries.length) {
        return;
      }

      var entry = entries[0];
      changeWidth(entry.contentRect.width);
      changeHeight(entry.contentRect.height);
    });
    resizeObserver.observe(element); // eslint-disable-next-line consistent-return

    return function () {
      return resizeObserver.unobserve(element);
    };
  }, []);
  return {
    ref: ref,
    width: width,
    height: height,
    hasSupport: hasSupport
  };
};

export default useResizeObserver;